

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';

/**
 * Helpers
 */
import { getInitials, getFullName } from './utils/users-helpers';

/**
 * Utils
 */
import { logout } from '@/utils/auth';

/**
 * API
 */
import usersAPI from '@/api/users';

/**
 * Components
 */
import AppNavigationDrawer from '@/components/_global/NavigationDrawer.vue';

/**
 *  Types
 */
import { SettingsResponseModel } from '@/api/settings';
import { ItemCategories } from '@/components/_global/NavigationDrawer.vue';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');


@Component({ components: { AppNavigationDrawer } })
export default class AppLayout extends Vue {
	/** Injections */
	getInitials = getInitials;
	getFullName = getFullName;

	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	@Prop()
	title!: string;

	drawer: boolean | null = null;
	currentUser: any = null;

	get itemCategories(): ItemCategories[] {
		return [
			{
				text: '',
				items: [
					{ icon: 'home', link: '/', text: 'menu.dashboard' }
				]
			},
			{
				text: 'menu.accounts',
				items: [
					{
						icon: 'account_balance_wallet', link: '/accounts/balance', text: 'menu.balance',
						enabled: (settings: SettingsResponseModel) => settings.payment.enableAccountsConsultation
					},
					{
						icon: 'fa-exchange-alt', link: '/accounts/transactions', text: 'menu.transactions',
						enabled: (settings: SettingsResponseModel) => settings.payment.enableAccountsConsultation
					},
				]
			},
			{
				text: 'menu.categories.services',
				items: [
					{
						icon: 'history', link: '/history', text: 'menu.history_bill',
						enabled: (settings: SettingsResponseModel) => settings.payment.enableAccountsConsultation
					},
					{
						icon: 'calendar_today', link: '/booking', text: 'menu.booking_time',
						enabled: (settings: SettingsResponseModel) => settings.booking.enableBooking
					},
					{
						icon: 'far fa-calendar-alt', link: '/booking_resources', text: 'menu.booking_resources',
						enabled: (settings: SettingsResponseModel) => settings.bookingResources.enable
					},
					{
						icon: 'shopping_cart', link: '/booking_shop', text: 'menu.booking_shop',
						enabled: (settings: SettingsResponseModel) => settings.bookingShop.enable
					},
				]
			}
		];
	}

	async created() {
		this.currentUser = await usersAPI.getCurrent();
	}


	async handleLogout() {
		await logout();
	}
}
